export default "__VITE_PUBLIC_ASSET__97d45998__"